export const contact = {
  contactName: "Naam",
  favoriteContact: "Gunstelinge",
  contactAction: "Aksie",
  contactEmail: "E-pos",
  contactTransfer: "Oopskakel",
  contactDelete: "Verwyder",
  contactDeleteMessage: "Wil jy regtig hierdie kontak verwyder?",
  contactEdit: "Wysig ",
  contactEditMessage: "Wil jy regtig hierdie kontak uit jou gunstelinglys wysig?",
  contactConfirmYes: "Ja",
  contactConfirmNo: "Nee",
  contactDeleteSuccess: "Kontak suksesvol verwyder!",
  contactAddSuccess: "Kontak suksesvol bygevoeg!",
  contactBackBtn: "Terug",
  contactsBtnAdd: "Voeg by",
  contactModalAdd: "Voeg kontak by",
  contactSearch: "Soek kontak",
  contactsTableUpdating: "Werk kontakte by...",
  contactLoading: "Laai kontakinligting...",
  contactError: "Fout met die laai van kontakinligting. Die kontak bestaan nie.",
  contactNotFound: "Kontak nie gevind nie.",
  contactAlreadyInList: "Kontak is reeds in die lys.",
  contactAddBtn: "Voeg by",
  contactCancelBtn: "Kanselleer",
  contactBackBtnText: "Terug",
  contactSearchRequired: "Voer 'n e-pos of alias in",
  contactSearchMinLength: "Minimum 3 karakters",
  contactSearchPlaceholder: "E-pos of alias",
};
